// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"kba-z","subtitle":"lba-z","wrapper":"mba-z","leftArrow":"nba-z","rightArrow":"oba-z"};